<div class="d-flex h-70">
  <h1 class="create-recipe-title" id="RecipesNewPageTitleLbl">{{ 'CREATE_RECIPE_TITLE' | translate }}</h1>
  <h3 class="create-recipe-subtitle">{{ 'CREATE_RECIPE_SUBTITLE' | translate }}</h3>
</div>

<form [formGroup]="formRecipe">
  <mat-card class="form-card">
    <mat-card-content>
      <div class="layout-horizontal-split">
        <div class="layout-horizontal-split-left">
          <div class="title selected">
            <div class="title-number">1</div>
            <h1 class="title-text">
              {{ 'DOMAIN' | translate }}
            </h1>
          </div>
          <mat-form-field class="form-field-xl margin-input" appearance="fill">
            <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
            <mat-select
              [value]="formRecipe.controls.domain.value"
              id="RecipesNewDomainBtn"
              (selectionChange)="selectDomain($event)"
              required
            >
              <div id="RecipesNewDomainLst">
                <mat-option *ngFor="let domain of domainsList | sortBy: 'translatedName'" [value]="domain.key">
                  {{ domain.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

          <div class="title {{ formRecipe.controls.domain.value ? 'selected' : '' }}">
            <div class="title-number">2</div>
            <h1 class="title-text">
              {{ 'MARKET' | translate }}
            </h1>
          </div>
          <ng-container *ngIf="formRecipe.controls.domain.value">
            <mat-form-field class="form-field-xl margin-input" appearance="fill">
              <mat-label>{{ 'MARKET' | translate }}</mat-label>
              <mat-select
                [value]="formRecipe.controls.market.value"
                id="RecipesNewMarketBtn"
                (selectionChange)="selectMarket($event.value)"
                required
              >
                <div id="RecipesNewMarketLst">
                  <mat-option *ngFor="let market of marketsList | sortBy: 'translatedName'" [value]="market.key">
                    {{ market.translatedName }}
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <div class="title {{ formRecipe.controls.market.value ? 'selected' : '' }}">
            <div class="title-number">3</div>
            <h1 class="title-text">
              {{ 'LANGUAGE' | translate }}
            </h1>
          </div>
          <div class="form-field-xl margin-input space-v-l" *ngIf="formRecipe.controls.market.value">
            <ng-container *ngFor="let language of languagesList | sortBy: 'translatedName'; let i = index">
              <button
                id="RecipesNewLangBtn{{ i + 1 }}"
                mat-raised-button
                type="button"
                class="btn-select"
                (click)="selectLanguage(language)"
                [class.btn-select-selected]="formRecipe.controls.lang.value === language.key"
              >
                {{ language.translatedName }}
              </button>
            </ng-container>
          </div>

          <div class="appliance-groups-wrapper">
            <div class="title {{ formRecipe.controls.lang.value ? 'selected' : '' }}">
              <div class="title-number">4</div>
              <h1 class="title-text">
                {{ 'APPLIANCE_GROUPS' | translate }}
              </h1>
            </div>
            <dcp-appliance-groups-control
              [appliancesAddButtonIdTag]="'RecipesAppliancesAllBtn'"
              *ngIf="formRecipe.controls.lang.value"
              [allApplianceGroups$]="applianceGroupsList$"
              [defaultApplianceGroupCtrl]="formRecipe.controls.defaultApplianceGroup"
              [listOfApplianceGroupsCtrl]="formRecipe.controls.applianceGroups"
              [defaultTranslation]="'DEFAULT' | translate"
            ></dcp-appliance-groups-control>
          </div>
        </div>

        <div class="layout-horizontal-split-right">
          <div class="title {{ formRecipe.controls.lang.value ? 'selected' : '' }}">
            <div class="title-number">5</div>
            <h1 class="title-text">
              {{ 'TITLE_AND_TYPE' | translate }}
            </h1>
          </div>
          <div *ngIf="formRecipe.controls.market.value && formRecipe.controls.lang.value">
            <div class="d-flex">
              <mat-form-field class="form-field-fixed-l margin-input space-h-l" appearance="fill">
                <mat-label>{{ 'TITLE' | translate }}</mat-label>
                <input
                  id="RecipesNewTitleTxt"
                  matInput
                  formControlName="title"
                  required
                  (ngModelChange)="bineratorLenghtTest('title')"
                  (blur)="bineratorLenghtTestOnFocus('title')"
                />
                <mat-error *ngIf="formRecipe.controls.title.hasError('required')"> {{ 'TITLE_REQUIRED' | translate }} </mat-error>
                <mat-error *ngIf="formRecipe.controls.title.hasError('binerator')">
                  {{ 'BINERATOR.RULES.TITLE.TOO_LONG' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <mat-form-field class="form-field-l margin-input" appearance="fill">
              <mat-label>{{ 'SUBTITLE' | translate }}</mat-label>
              <input
                id="RecipesNewShortTitleTxt"
                matInput
                formControlName="shortTitle"
                (ngModelChange)="bineratorLenghtTest('shortTitle')"
                (blur)="bineratorLenghtTestOnFocus('shortTitle')"
              />
              <mat-error *ngIf="formRecipe.controls.shortTitle.hasError('required')"> {{ 'SUBTITLE_REQUIRED' | translate }} </mat-error>
              <mat-error *ngIf="formRecipe.controls.shortTitle.hasError('binerator')">
                {{ 'BINERATOR.RULES.SHORT_TITLE.TOO_LONG' | translate }}
              </mat-error>
            </mat-form-field>
            <br />

            <mat-form-field class="form-field-xxl margin-input" appearance="fill">
              <mat-label>{{ 'COURSE_TYPE' | translate }}</mat-label>
              <mat-select formControlName="courses" id="RecipesNewMealsTypeBtn" multiple>
                <div id="RecipesNewMealsTypeChkBox">
                  <mat-option *ngFor="let type of courseTypes" [value]="type.key">{{ type.labelInt || type.en || type.key }}</mat-option>
                </div>
              </mat-select>
            </mat-form-field>

            <div class="margin-input">
              <app-form-yield
                [formGroup]="formRecipe"
                [yieldUnits]="filteredYieldUnits"
                [lang]="formRecipe.controls.lang.value"
                [market]="formRecipe.controls.market.value"
              ></app-form-yield>
            </div>

            <div class="margin-input">
              <mat-checkbox id="RecipesNewPayableChkBox" formControlName="isPremium" class="mt-2">{{
                'IS_PREMIUM' | translate
              }}</mat-checkbox>

              <span>
                <mat-hint class="hint">
                  <mat-icon aria-hidden="false" aria-label="hint icon" class="icon">info</mat-icon>
                  {{ 'NOT_EDITABLE_FIELD' | translate }}
                </mat-hint>
              </span>
            </div>

            <div class="margin-input">
              <mat-checkbox id="RecipesNewAIGeneratedChkBox" formControlName="isAIGenerated" class="mt-2">{{
                'GENERATED_WITH_AI' | translate
              }}</mat-checkbox>
            </div>
          </div>

          <div
            class="title {{
              formRecipe.controls.title.value &&
              formRecipe.controls.yieldQuantity.value !== '' &&
              !formRecipe.controls.yieldQuantity.hasError('required') &&
              formRecipe.controls.yieldUnit.value
                ? 'selected'
                : ''
            }}"
          >
            <div class="title-number">6</div>
            <h1 class="title-text">
              {{ 'PHOTO_AND_PHOTOTHEQUE' | translate }}
            </h1>
          </div>
          <ng-container
            *ngIf="
              formRecipe.controls.title.value &&
              formRecipe.controls.yieldQuantity.value !== '' &&
              !formRecipe.controls.yieldQuantity.hasError('required') &&
              formRecipe.controls.yieldUnit.value
            "
          >
            <app-media-upload
              class="margin-input"
              [formControlName]="'resourceMedias'"
              [withUrlInput]="true"
              [width]="600"
              [singleImage]="true"
            ></app-media-upload>
          </ng-container>

          <br />
          <button
            id="RecipesNewCreateBtn"
            mat-button
            class="btn btn-submit margin-input space-t-xxl"
            [disabled]="formRecipe.invalid || !this.formRecipe.controls.lang.value"
            (click)="save.emit()"
          >
            {{ 'CREATE_RECIPE' | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
